// @flow

export default (integer: number, roundNumber?: number = 1000) => (
  roundNumber === 0
    ? integer
    : Math.round(integer / roundNumber) * roundNumber
);
